import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledHero,
  StyledPreTitle,
  StyledWrapper
} from './DailyHero.styled';

const DailyHero: React.FC = () => {
  const { t } = useI18n('manfred-daily');

  return (
    <StyledHero>
      <StyledWrapper>
        <StyledContainer>
          <div>
            <StyledPreTitle>{t('manfred-daily.hero.pre-title')}</StyledPreTitle>
            <Heading2 as="h1">{t('manfred-daily.hero.title')}</Heading2>
          </div>
          <img src={getPublicPath(`/images/manfredDaily/hero.svg`)} alt="" />
        </StyledContainer>
      </StyledWrapper>
    </StyledHero>
  );
};

export default DailyHero;
